import { render, staticRenderFns } from "./FinalExamProtocolsView.vue?vue&type=template&id=7913793c"
import script from "./FinalExamProtocolsView.vue?vue&type=script&lang=js"
export * from "./FinalExamProtocolsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports